import { z } from 'zod'

/* Notices API */

/**
 * Type for 'NoticeResponseItem' (backend API data type).
 * @param id Unique Notice ID.
 * @param content Notice content.
 * @param createdAt Notice creation time as epoch seconds.
 * @param readByUser Flag indicating whether logged in user has already read the notice.
 */
export interface NoticeResponseItem {
  id: string
  content: string
  createdAt: number
  readByUser: boolean
}

/**
 * Schema for 'NoticeResponseItem' (backend API data type).
 */
export const NoticeResponseItemSchema = z.object({
  id: z.string(),
  content: z.string(),
  createdAt: z.number(),
  readByUser: z.boolean()
})

/**
 * Schema for 'NoticeResponseItem' list response.
 */
export const NoticeResponseItemsSchema = z.array(NoticeResponseItemSchema)
